import React from 'react';
import Slider from '@mui/material/Slider';
import { ListFacetGroup } from '../ListFacetGroup';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { IntlProvider, FormattedMessage, FormattedNumber } from 'react-intl';
import ar from './ar.json';
import en from './en.json';
import { LocaleContext } from '../../../../contexts/language';

const languages = {
  ar,
  en
};
const getSelectedValue = ({ requestedValue, minValue, maxValue, defaultValue }) => {
  if (isNaN(parseFloat(requestedValue))) {
    return defaultValue;
  }
  if (parseFloat(requestedValue) < minValue) {
    return minValue;
  }
  if (parseFloat(requestedValue) > maxValue) {
    return maxValue;
  }
  return parseFloat(requestedValue);
};


const RangeFacet = ({ name, min, max, unit, requestedMin, requestedMax, onChange, step }) => {
  const localeConfig = React.useContext(LocaleContext);
  const maxCeil = step ? Math.ceil(max / step) * step : max;
  const minFloor = step ? Math.floor(min / step) * step : min;

  const actualMin = getSelectedValue({ requestedValue: requestedMin, maxValue: maxCeil, minValue: minFloor, defaultValue: minFloor });
  const actualMax = getSelectedValue({ requestedValue: requestedMax, maxValue: maxCeil, minValue: minFloor, defaultValue: maxCeil });

  const [[cMin, cMax], setCurrentValue] = React.useState([actualMin, actualMax]);
  React.useEffect(() => {
    const newMin = getSelectedValue({ requestedValue: requestedMin, maxValue: maxCeil, minValue: minFloor, defaultValue: minFloor });
    const newMax = getSelectedValue({ requestedValue: requestedMax, maxValue: maxCeil, minValue: minFloor, defaultValue: maxCeil });
    setCurrentValue([newMin, newMax]);
  }, [minFloor, maxCeil, requestedMin, requestedMax]);
  return (
    <ListFacetGroup
      name={name}
      onReset={()=>{onChange([null,null]);setCurrentValue([minFloor,maxCeil]);}}
    >
      <IntlProvider locale={localeConfig?.lang} messages={languages[localeConfig?.lang] || languages.en}>
        <Stack spacing={2}>
          <Typography sx={{ fontSize: '0.8rem', fontWeight: 300 }}>
            <FormattedMessage id={'rangeFacet.from.generic'} defaultMessage={'From {from}{unit} to {to}{unit}'}
              values={{
                from: <FormattedNumber
                  minimumFractionDigits={unit === 'currency' ? 0 : undefined}
                  maximumFractionDigits={unit === 'currency' ? 0 : undefined}
                  style={unit === 'currency' ? unit : undefined}
                  currency={unit === 'currency' ? 'AED' : undefined}
                  value={cMin}
                />,
                unit: unit === 'currency' ? '' : unit,
                to: <FormattedNumber
                  minimumFractionDigits={unit === 'currency' ? 0 : undefined}
                  maximumFractionDigits={unit === 'currency' ? 0 : undefined}
                  style={unit === 'currency' ? unit : undefined}
                  currency={unit === 'currency' ? 'AED' : undefined}
                  value={cMax}
                />
              }}
            />
          </Typography>
          <Box
            sx={{ pr: 3, pl: 3 }}>
            <Slider
              getAriaLabel={() => name}
              value={cMin < cMax ? [cMin, cMax] : [min || 0, max || 0]}
              onChangeCommitted={() => {
                onChange([cMin === minFloor ? null : cMin, cMax === maxCeil ? null : cMax]);
              }}
              step={step}
              onChange={(e) => {
                const [newMin, newMax] = e.target.value;
                setCurrentValue([newMin, newMax]);
              }}
              valueLabelDisplay="auto"
              valueLabelFormat={x => <FormattedNumber
                minimumFractionDigits={unit === 'currency' ? 0 : undefined}
                maximumFractionDigits={unit === 'currency' ? 0 : undefined}
                style={unit === 'currency' ? unit : undefined}
                currency={unit === 'currency' ? 'AED' : undefined}
                value={x}
              />}
              getAriaValueText={() => `${actualMin}-${actualMax}`}
              disableSwap
              min={minFloor || 0}
              max={maxCeil || 0}
            />
          </Box>
        </Stack>
      </IntlProvider>
    </ListFacetGroup>
  );
};
RangeFacet.propTypes = {
  unit: PropTypes.string,
  name: PropTypes.node.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  requestedMin: PropTypes.number,
  requestedMax: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  step: PropTypes.number
};
RangeFacet.defaultProps = {
  onChange: () => {
  }
};
export default RangeFacet;
export { RangeFacet };